<template>
  <div class="app-header">
    <div class="app-header__container container">
      <div class="app-header__left">
        <!--
        <HamburgerIcon
          v-if="!showSidebar"
          class="app-header__menu-button"
          @click.native="toggleSidebar" />
        <CloseIcon
          v-else
          class="app-header__menu-button"
          @click.native="toggleSidebar" />
          -->

        <a
          class="h-full underline"
          href="https://adra.org/">
          <img
            src="@/assets/new-adra-logo.png"
            class="h-full w-auto cursor-pointer" >
        </a>
      </div>
      <!--
      <div class="app-header__right">
        <div v-if="!loggedIn">
          <router-link
            :to="{ name: 'UserSignup' }"
            tag="button"
            class="button button-outline button-sm button-header mr-2"
            @click.native="closeSidebar">
            Signin
          </router-link>
        </div>
        <a
          v-else
          class="app-header__logout"
          href="#"
          @click.prevent="logout">
          Logout
        </a>
      </div>
      -->
    </div>
  </div>
</template>

<script>
import AdraLogo from '@/assets/adra-logo.svg'
import CloseIcon from '@/assets/i-close.svg'
import HamburgerIcon from '@/assets/i-hamburger.svg'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AppHeader',

  components: {
    AdraLogo,
    CloseIcon,
    HamburgerIcon
  },

  computed: {
    ...mapState({
      loggedIn: state => state.auth.loggedIn,
      showSidebar: state => state.showSidebar
    })
  },

  methods: {
    logout() {
      this.resetAuth()
      this.$router.push({ name: 'UserLogin' })
    },

    closeSidebar() {
      this.setSidebar(false)
    },

    toggleSidebar() {
      this.setSidebar(!this.showSidebar)
    },

    ...mapActions({
      resetAuth: 'auth/reset',
      setSidebar: 'setSidebar'
    })
  }
}
</script>
